import React from "react";

export const Image = ({ title, link, image}) => {

  return (
    <div className="portfolio-item">
      <div className="hover-bg image-bg">
        <a href={link} target="_blank" rel="noopener noreferrer" title={title} >
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={image} className="portfolio-img img-responsive" alt={title} /> 
        </a>
      </div>
    </div>
  );
};
